import React, { createContext, useState, useContext } from "react";
import { DESIGN_PRESETS } from "./DesignPresets";

const StudioContext = createContext();

export const useStudio = () => useContext(StudioContext);

export const StudioProvider = ({ children }) => {

  const defaultDesign = "floral-001";
  const defaultPreset = DESIGN_PRESETS[defaultDesign];

  const [formData, setFormData] = useState({
    ...defaultPreset,
    language: 'BM',
    designCode: 'floral-001',
    packageType: 'Standard',
    eventType: 'Majlis Perkahwinan',
    coupleCount: 'satu',
    openCardName: '',
    greetingName: '',
    eventHost: 'satu',
    eventSide: 'lelaki',
    parentName: 'Abu Bakar Bin Ahmad & Aminah Binti Zulkifli',
    parentNameMale: '',
    parentNameFemale: '',
    groomName: 'Adam Bin Abu Bakar',
    brideName: 'Hawa Binti Ismail',
    greetingName2: 'Zaid & Layla',
    groomName2: '',
    brideName2: '',
    openingText: 'Assalamualaikum W.B.T',
    greetingText: "Dengan penuh kesyukuran kehadrat Ilahi, \nkami menjemput \nDato' | Datin | Tuan | Puan | Encik | Cik \nke majlis perkahwinan anakanda kami",
    closingText: 'Semoga kehadiran para tetamu memeriahkan lagi majlis ini serta mendapat keberkatan daripada Allah S.W.T.',
    openingStyle: 'Tingkap A',
    openingColor: '#f2f2f2',
    fontColor: '#FF238a',
    fontStyle: 'Helvetica',
    eventDate: '25 Dec 2026',
    day: 'Sabtu',
    place: '',
    eventAddress: 'Dewan Putra Kulim,\nLebuh Bandar 2, Bandar Putra,\n09000 Kulim Kedah',
    googleMapLink: 'https://maps.app.goo.gl/HaLzxT6hrgPqWf5V9',
    wazeMapLink: 'https://ul.waze.com/ul?place=ChIJ0UL7ae_LSjARiFlXZVZQd2A&ll=5.37195730%2C100.54181670&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location',
    dressCode: 'Formal / Tradisional',
    dressCodeNotes: '',
    dressCodeColours: [],
    startTime: '11:00',
    endTime: '17:00',
    textLayoutMajlis: 'inline',
    fontSizeMajlis: 16,
    fontSizePengantin: 50,
    programmes: [
      { time: '11:00', activity: 'Majlis Bermula' },
      { time: '13:00', activity: 'Ketibaan Pengantin' },
      { time: '14:00', activity: 'Makan Beradab' },
      { time: '17:00', activity: 'Majlis Berakhir' }
    ],
    totalGuest: 500,
    guestPerPax: 4,
    slotTimes: [
      { slotTimeStart: '11:00', slotTimeEnd: '12:00', label: 'Keluarga', guestPerPax: '', totalGuest: '' }
    ],
    contactDetails: [
      { contactName: 'Abu Bakar', relationship: 'Bapa', contactPhoneNum: '0123456789' },
      { contactName: 'Aminah Zulkifli', relationship: 'Emak', contactPhoneNum: '0121231229' },
      { contactName: 'Syazwan Bakar', relationship: 'Abang', contactPhoneNum: '0131234529' },
    ],
    musicYoutubeURL: '',
    musicStartDuration: '',
    musicTitle: '',
    sliderImage1: '',
    sliderImage2: '',
    sliderImage3: '',
    bankName: 'Maybank',
    bankAccountNumber: '123456789012',
    bankAccountName: 'Adam Bin Abu Bakar',
    bankQRImage: '',
    brideAddress: '',
    gifts: [],
    showRSVP: true,
    showSlotTime: false,
    showOnlyWishes: false,
    showQRBank: false,
    showWishlistGift: false,
    isDraft: true,
    weatherForecast: false
  });

  return (
    <StudioContext.Provider value={{ formData, setFormData }}>
      {children}
    </StudioContext.Provider>
  );
};
